import { render, staticRenderFns } from "./ModuleLearnPlan.vue?vue&type=template&id=5b8e0f96&scoped=true"
import script from "./ModuleLearnPlan.vue?vue&type=script&lang=js"
export * from "./ModuleLearnPlan.vue?vue&type=script&lang=js"
import style0 from "./ModuleLearnPlan.vue?vue&type=style&index=0&id=5b8e0f96&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./ModuleLearnPlan.vue?vue&type=style&index=1&id=5b8e0f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e0f96",
  null
  
)

export default component.exports